module.exports = __webpack_public_path__ + "static/media/am_place-a-hold.2d75c294.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_place-a-hold.md
// module id = 1089
// module chunks = 0